import React from "react";
import { Region } from "../../models/calculation-api.types";
import { CalculatorV2ConfigurationModel } from "../../models/calculator-configuration";

export type CTAButtonsProps = {
  config: CalculatorV2ConfigurationModel;
  region: Region;
  translations: { [key: string]: string };
};

export const CTAButtons = ({ config, region, translations }: CTAButtonsProps) => {
  const ctaOnboardingUrl =
    region === Region.Flanders
      ? config.Flanders.CTAOnboardingUrl
      : region === Region.Wallonia
      ? config.Wallonia.CTAOnboardingUrl
      : config.Brussels.CTAOnboardingUrl;

  const ctaTransferUrl =
    region === Region.Flanders
      ? config.Flanders.CTATransferUrl
      : region === Region.Wallonia
      ? config.Wallonia.CTATransferUrl
      : config.Brussels.CTATransferUrl;

  return (
    <div className="row">
      <div className="col-12">
        <div className="float-right">
          {ctaOnboardingUrl ? (
            <a href={ctaOnboardingUrl} className="btn btn-primary w-20 mr-2 mb-2">
              {translations.CTAOnboardingUrl}
            </a>
          ) : null}
          {ctaTransferUrl ? (
            <a href={ctaTransferUrl} className="btn btn-primary w-20 mb-2">
              {translations.CTATransferUrl}
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};
